<template>
  <div class="app-container">
    <navigation title="检索"></navigation>
    <div class="search_tip">闭架文献阅览须知：发送预约请求有效受理时间为周二至周日（周一不提供，如遇节假日以官网通知为准）0:00-16:00，预约请求当日有效。</div>
    <div class="search">
      <van-search v-model="searchTitle" placeholder="请输入关键词"  @search="onSearch" class="search-inp" center>
        <template #right-icon>
          <button class="search-btn" @click="onSearch">检索</button>
        </template>
      </van-search>
    </div>
    <div class="main">
      <!--检索历史-->
      <div class="history" v-if="historyList.length>0">
        <van-cell title="检索历史">
          <template #right-icon>
            <div @click="localDelete">
              <svg-icon iconClass='delete' className='icon' class="delete"></svg-icon>
            </div>
          </template>
        </van-cell>
        <ul class="history-list">
          <li v-for="item in historyList" @click="historyClick(item)">{{ item }}</li>
        </ul>
      </div>
      <!--更多选项-->
      <div class="opac-select" v-if="active===0">
        <p class="more-select"  @click="isMore=!isMore">
          更多选项
          <van-icon name="arrow-up" v-if="isMore"/>
          <van-icon name="arrow-down" v-else/>
        </p>
        <div v-if="isMore">
          <van-field
            readonly
            clickable
            name="picker"
            :value="value"
            placeholder="点击选择"
            @click="showPicker = true"
            right-icon="arrow-down"
          >
            <template #label>
              <div class="label">
                <span class="file-label">检索字段</span>
                <span class="label-bor"></span>
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
          </van-popup>
          <van-field readonly clickable name="picker" :value="value1" placeholder="点击选择" @click="showPicker1 = true" right-icon="arrow-down">
            <template #label>
              <div class="label">
                <span class="file-label">词邻近</span>
                <span class="label-bor"></span>
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPicker1" position="bottom">
            <van-picker show-toolbar :columns="columns1" @confirm="onConfirm1" @cancel="showPicker1 = false"/>
          </van-popup>
        </div>
      </div>
      <van-tabs v-model="active" @click="tabClick" :ellipsis="false">
        <template #nav-right>
          <div class="resources-filter" v-if="active===1">
            <van-field readonly clickable name="picker" :value="reTypeValue" placeholder="点击选择" @click="reFilter">
              <template #right-icon>
                <svg-icon iconClass='arrow-grey' className='icon'></svg-icon>
              </template>
            </van-field>
          </div>
        </template>
        <van-tab title="馆藏目录">
          <!--筛选-->
          <div class="filter">
            <p class="filter-title" v-if="isFilter" @click="isFilter=false">筛选
              <van-icon name="arrow-up"/>
            </p>
            <p class="filter-title" v-else  @click="isFilter=true">筛选
              <van-icon name="arrow-down"/>
            </p>
            <div class="filter-content" v-if="isFilter">
              <div class="filter-list">
                <div class="filter-list-col filter-width">
                  <van-field class="filter-file" readonly clickable name="picker" label="出版年" placeholder="请选择出版年"
                             @click="showPickerSY = true" :value="startValue.key" center>
                    <template #right-icon>
                      <svg-icon iconClass='arrow' className='icon'></svg-icon>
                    </template>
                  </van-field>
                </div>
                <div class="filter-list-col filter-width">
                  <van-field class="filter-file" readonly clickable name="picker" label="资料类型" placeholder="请选择"
                             @click="showPickerTy = true" :value="dataText" center>
                    <template #right-icon>
                      <svg-icon iconClass='arrow' className='icon'></svg-icon>
                    </template>
                  </van-field>
                </div>
              </div>
              <div class="filter-list filter-last">
                <span class="radio-label">数据库</span>
                <van-checkbox-group v-model="dataRadio" direction="horizontal"  icon-size="16px">
                  <van-checkbox name="NLC01S" shape="square">中文数据库</van-checkbox>
                  <van-checkbox name="NLC09S" shape="square">外文数据库</van-checkbox>
                </van-checkbox-group>
              </div>
              <div class="filter-btn">
                <van-button class="filter-reset" @click="filterReset">重置</van-button>
                <van-button class="filter-confirm" @click="filterConfirm">确定</van-button>
              </div>
            </div>
          </div>
          <div class="all-title" v-if="opacListTotal!==''">
            <div class="add-box">找到相关记录，共<span class="all-total">{{opacListTotal}}</span>条</div>
            <div class="all-data" v-if="changeShow">
              <span :class="params.base && params.base.indexOf('NLC01S')>-1?'all-data-active':''" @click="changeData('NLC01S')">中文</span>
              <span>/</span>
              <span :class="params.base && params.base.indexOf('NLC09S')>-1?'all-data-active':''" @click="changeData('NLC09S')">外文</span>
            </div>
          </div>
          <van-list
            v-model="opacLoading"
            :finished="opacFinished"
            finished-text="没有更多了"
            @load="searchOpac"
            v-if="opacList.length>0"
          >
            <van-cell class="list-border" v-for="item in opacList">
              <template #title>
                <div v-html="item['title-highlights']"></div>
              </template>
              <template #label>
                <p class="message message-size" v-if="item.publishHouse">出版社：{{ item.publishHouse }}</p>
                <p class="message message-size" v-if="item.author">作者：{{ item.author }}</p>
                <p class="message message-size" v-if="item.publishYear">出版年：{{ item.publishYear }}</p>
                <p class="message message-size" v-if="item.type">资料类型：{{ item.type }}</p>
<!--                <p class="message message-size" v-if="item.isbn">ISBN：{{ item.isbn }}</p>-->
<!--                <p class="message message-size message-over" v-if="item.summary">内容：{{ item.summary }}</p>-->
                <button class="opacList-view" @click="goView(item)">查看单册信息</button>
              </template>
            </van-cell>
          </van-list>
          <div v-else class="no-list">
            <p>{{ opacTitle }}</p>
          </div>
        </van-tab>
        <van-tab title="数字资源">
          <div class="all-title" v-if="onsiteListTotal">找到相关记录，共<span class="all-total">{{onsiteListTotal}}</span>条</div>
          <van-list
            v-model="resourcesLoading"
            :finished="resourcesFinished"
            finished-text="没有更多了"
            @load="resourcesOnLoad"
            v-if="onsiteList.length>0"
          >
            <van-cell :clickable="false" class="list-border" v-for="item in onsiteList" @click="goOnsite(item.resType,item.resId)">
              <template #icon>
                <div class="resources-left">
                  <van-image
                    v-if="item.coverUrl"
                    fit="contain"
                    :src="item.coverUrl"
                    class="resources-img"
                  />
                  <img
                    v-else
                    src="@/assets/img/resource.png"
                    class="resources-img"
                  />
<!--                  <img :src="item.coverUrl" alt="" class="resources-img">-->
                  <div class="resources-categoryName">
                    <span>{{ item.categoryName }}</span>
                    <svg-icon v-if="item.resType==='BOOK' || item.resType==='PERIODICAL'" iconClass='book-magazine' className='icon'></svg-icon>
                    <svg-icon v-else-if="item.resType==='AUDIO'" iconClass='res-audio' className='icon'></svg-icon>
                    <svg-icon v-else="item.resType==='VIDEO'" iconClass='res-video' className='icon'></svg-icon>
                  </div>
                </div>
              </template>
              <template #title>
                <span class="onsite-title" v-html="item['name-highlights']">{{ item.name }}</span>
                <span class="author">作者：{{ item.author }}</span>
                <span class="shortIntro" v-if="item.shortIntro">简介：{{ item.shortIntro }}</span>
              </template>
            </van-cell>
          </van-list>
          <div v-else class="no-list">
            <p>{{ resourcesTitle }}</p>
          </div>
        </van-tab>
        <van-tab title="站内" class="on-site">
          <div class="all-title" v-if="onsiteListTotal">找到相关记录，共<span class="all-total">{{onsiteListTotal}}</span>条</div>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            v-if="onsiteList.length>0"
          >
            <van-cell :clickable="false" class="list-border" v-for="(item) in onsiteList" @click="goDetail(item)">
              <template #title>
                <div class="onsite-title" v-html="item['title-highlights']"></div>
              </template>
              <template #label>
                <div class="onsite-label">
                  <span class="message">{{ item.createTime }}</span>
                  <span class="search-source">搜索来源：{{ item.module }}</span>
                </div>
              </template>
            </van-cell>
          </van-list>
          <div v-else class="no-list">
            <p>{{ noTitle }}</p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!--选择弹窗-->
    <div>
      <!--出版年-->
      <van-popup v-model="showPickerSY" position="bottom">
        <van-datetime-picker type="year-month" title="选择年月" :min-date="minDate" :max-date="maxDate" v-model="currentDate"
                             @confirm="onConfirmSY" @cancel="yearCancel" />
      </van-popup>
      <!--资料类型-->
      <van-popup v-model="showPickerTy" position="bottom">
        <van-picker show-toolbar :columns="dataType" @confirm="onConfirmTy" @cancel="showPickerTy = false"/>
      </van-popup>
      <!--数字资源-->
      <van-popup v-model="showPickerType" position="bottom">
        <van-picker show-toolbar :columns="reType" @confirm="onConfirmRe" @cancel="showPickerType = false"/>
      </van-popup>
    </div>
    <scroll></scroll>
    <version></version>
    <page-share :show="showShare" @show='getShow'></page-share>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup, Tab, Tabs, Picker, Toast } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import pageShare from '../../components/pageShare'
import version from '../../components/version'
import {parseTime} from '../../untils/formatTime'
import scroll from '../../components/scroll'
import { Image as VanImage } from 'vant';

Vue.use(VanImage)

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Tab).use(Tabs).use(Picker).use(Toast)
export default {
  name: 'search',
  components: {navigation, pageShare, version, scroll},
  data () {
    return {
      active: 0,
      value: '全部', // 检索字段初始值
      columns: [
        {
          text: '全部',
          code: 'WRD'
        },
        {
          text: '正题名',
          code: 'WTP'
        },
        {
          text: '其它题名',
          code: 'WTI'
        },
        {
          text: '著者',
          code: 'WAU'
        },
        {
          text: '主题词',
          code: 'WSU'
        },
        {
          text: '中图分类号',
          code: 'CLC'
        },
        {
          text: '论文专业',
          code: 'WSC'
        },
        {
          text: '论文研究方向',
          code: 'WRS'
        },
        {
          text: '论文学位授予单位',
          code: 'WDU'
        },
        {
          text: '论文学位授予时间',
          code: 'WDD'
        },
        {
          text: '出版地',
          code: 'WPL'
        },
        {
          text: '出版者',
          code: 'WPU'
        },
        {
          text: '丛编',
          code: 'WSE'
        },
        {
          text: '索取号',
          code: 'SHL'
        },
        {
          text: 'ISSN',
          code: 'ISS'
        },
        {
          text: 'ISBN',
          code: 'ISB'
        },
        {
          text: 'ISRC',
          code: 'SRC'
        },
        {
          text: '条码号',
          code: 'BAR'
        },
        {
          text: '系统号',
          code: 'SYS'
        }
      ], // 检索字段弹框列表
      showPicker: false, //检索字段弹框初始化
      value1: '是', // 词临近初始值
      columns1: ['是', '否'], // 词临近弹框列表
      showPicker1: false, // 词临近弹框初始化
      opacCode: 'WRD', // 搜索框字段默认code
      params: {
        pageNum: '1',
        pageSize: '10'
      },
      searchTitle: '',
      loading: false,
      finished: false,
      onsiteList: [],
      onsiteListTotal: null,
      resourcesLoading: false,
      resourcesFinished: false,
      showShare: false,
      opacLoading: false,
      opacFinished: false,
      opacList: [],
      opacListTotal:'',
      noTitle: '搜索您要查找的内容',
      resourcesTitle: '搜索您要查找的内容',
      opacTitle: '搜索您要查找的内容',
      isMore: false,
      isFilter: false,
      historyList: [],
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showPickerSY:false,
      startValue: {
        key: '全部',
        code: 'WYR'
      }, // 出版年
      dataType:[
        {
          text: '全部',
          value: ''
        },
        {
          text: '图书',
          value: 'BK'
        },
        {
          text: '报刊',
          value: 'SE'
        },
        {
          text: '音视频和电子资源',
          value: 'MU'
        }
      ],//资料类型
      dataValue:{
        key: '全部',
        code: 'WFM'
      },
      dataText:'全部',
      showPickerTy:false,
      showPickerType: false,
      reType:[
        {
          text: '全部',
          code: 'ALL'
        },
        {
          text: '图书',
          code: 'BOOK'
        },
        {
          text: '音频',
          code: 'AUDIO'
        },
        {
          text: '视频',
          code: 'VIDEO'
        },
        // {
        //   text: '期刊',
        //   code: 'PERIODICAL'
        // }
      ],// 数字资源筛选列表
      reTypeValue:'全部', // 数字资源筛选默认
      resType: 'ALL',
      dataRadio: ['NLC01S'],
      changeShow:false
    }
  },
  watch:{
    dataRadio(newVal,oldVal){
      console.log('newVal',newVal)
      if(newVal.length===0){
        Toast.fail('数据库选择不能为空')
      }
    }
  },
  created () {
    if(this.$route.params.active) {
      this.active = this.$route.params.active
    }
    if (`${history}` in localStorage) { // 检测搜索记录存在时
      this.historyList = JSON.parse(localStorage[history]);
    }
  },
  activated () {
    if(this.$route.params.active) {
      this.active = this.$route.params.active
    }
  },
  methods: {
    // 站内搜索
    onLoad () {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      this.params.key = this.searchTitle
      request('get', '/nlc-web/api/search', this.params).then(res => {
        console.log('站内搜索结果', res)
        if(res.data.content.length===0){
          this.noTitle = '未查找到您搜索的内容'
        }
        this.onsiteListTotal = res.data.totalElements
        for (let i = 0; i < res.data.content.length; i++) {
          this.onsiteList.push(res.data.content[i])
        }
        this.highlights ()
        Toast.clear()
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.onsiteList.length) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      this.params.pageNum++
    },
    // 资源
    resourcesOnLoad () {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      console.log('this.searchTitle', this.searchTitle)
      this.params.content = this.searchTitle
      this.params.resType = this.resType
      request('get', '/nlc-api/api/readOpen/searchApi', this.params).then(res => {
        console.log('资源搜索结果', res)
        if(res.code!==200){
          Toast.fail(res.msg)
        }
        if(res.data.content.length===0){
          this.resourcesTitle = '未查找到您搜索的内容'
        }
        this.onsiteListTotal = res.data.totalElements
        for (let i=0;i<res.data.content.length;i++) {
          this.onsiteList.push(res.data.content[i])
        }
        this.resourceHighlights ()
        Toast.clear()
        // 加载状态结束
        this.resourcesLoading = false
        if (res.data.totalElements === this.onsiteList.length) {
          this.resourcesFinished = true
        } else {
          this.resourcesFinished = false
        }
      })
      this.params.pageNum++
    },
    // opac搜索
    searchOpac () {
      if(this.dataRadio.length===0){
        Toast.fail('数据库选择不能为空')
        return;
      }
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      console.log('this.params.base',this.params.base)
      if(!this.params.base){
        this.params.base = 'NLC01S'
      }
      // 词临近
      this.params.adjacent = this.value1 === '是' ? 'Y' : 'N'
      this.params.params=[
        {
          key: this.searchTitle,
          code:this.opacCode
        }
      ]
      if (this.isFilter===true) {
        if (this.startValue.key) {
          let start = ''
          if(this.startValue.key==='全部'){
            start ={
              key: '',
              code: this.startValue.code
            }
          } else {
            start ={
              key: this.startValue.key,
              code: this.startValue.code
            }
          }
          this.params.params.push(start)
        }
        if (this.dataValue) {
          if (this.dataValue.key==='全部'){
            this.dataValue.key = ''
          }
          this.params.params.push(this.dataValue)
        }
      }
      request('post', '/nlc-api/api/nlc/alephSearch/params', this.params).then(res => {
        console.log('搜索结果', res)
        if(this.dataRadio.length>1){
          this.changeShow = true
        } else {
          this.changeShow = false
        }
        if(res.code !== 200) {
          if(res.msg){
            Toast.fail(res.msg)
            if(res.msg==='暂无相关数据'){
              this.opacTitle = '未查找到您搜索的内容'
              this.opacList = []
              this.opacListTotal = 0
            }
          } else {
            Toast.fail('请求失败')
          }
        } else {
          Toast.clear()
          if(res.data.content){
            if(res.data.content.length<0){
              this.opacTitle = '未查找到您搜索的内容'
            } else {
              this.opacListTotal = res.data.totalElements
              for (let i = 0; i < res.data.content.length; i++) {
                this.opacList.push(res.data.content[i])
              }
            }
          }
        }
        this.opacHighlights ()
        this.opacLoading = false
        if (res.data.totalElements === this.opacList.length ) {
          this.opacFinished = true
        } else {
          this.opacFinished = false
        }
      }).catch(e => {
        Toast.fail('请求超时，请稍后再试')
      })
      this.params.pageNum++
    },
    // 搜索
    onSearch () {
      if(!this.searchTitle){
        Toast.fail('请输入搜索关键词')
        return;
      }
      this.localAdd(history,this.searchTitle)
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      this.params.pageNum = '1'
      this.onsiteList = []
      this.opacList = []
      this.finished = false
      this.resourcesFinished = false
      this.opacFinished = false
      // 词临近 delete this.params.adjacent
      // 中文外文 delete this.params.base
      // 出版年 资料类型 delete this.params.params
      // delete this.params.key
      if(this.dataRadio.length===1){
        this.params.base = this.dataRadio[0]
      }
      if(this.dataRadio.indexOf('NLC01S')>-1){
        this.params.base = 'NLC01S'
      } else {
        this.params.base = 'NLC09S'
      }
      if (this.active === 2) {
        this.onLoad()
      } else if (this.active === 1) {
        this.resourcesOnLoad()
      } else {
        this.searchOpac ()
      }
    },
    // 中外文切换
    changeData (type) {
      this.params.base = type
      this.params.pageNum = '1'
      this.opacList = []
      this.opacFinished = false
      this.searchOpac()
    },
    // tab切换
    tabClick () {
      this.params.pageNum = '1'
      this.onsiteList = []
      this.opacList = []
      delete this.params.adjacent
      delete this.params.base
      delete this.params.params
      delete this.params.key
      this.finished = false
      this.resourcesFinished = false
      this.opacFinished = false
      if (this.active === 2 && this.searchTitle !== '') {
        this.onLoad()
      } else if (this.active === 1 && this.searchTitle !== '') {
        this.resourcesOnLoad()
      } else if (this.active === 0 && this.searchTitle !== '') {
        this.searchOpac()
      }
    },
    // 数字资源筛选
    reFilter(){
      if(!this.searchTitle){
        Toast.fail('请输入搜索关键词')
        return;
      }
      this.showPickerType = true
    },
    // 检索历史检索
    historyClick (text) {
      this.searchTitle = text
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      this.params.pageNum = '1'
      this.onsiteList = []
      this.opacList = []
      this.finished = false
      this.resourcesFinished = false
      this.opacFinished = false
      delete this.params.adjacent
      delete this.params.base
      delete this.params.params
      delete this.params.key
      if(this.dataRadio.length===1){
        this.params.base = this.dataRadio[0]
      }
      if (this.active === 2) {
        this.onLoad()
      } else if (this.active === 1) {
        this.resourcesOnLoad()
      } else {
        this.searchOpac ()
      }
    },
    // 添加搜索记录
    localAdd(name,value){
      let stu;
      let stuStr;
      if (`${name}` in localStorage){//检测搜索记录存在时
        stu= JSON.parse(localStorage[name]);
        for (let i = 0; i < stu.length; i++) {
          if (value == stu[i]){
            return
          }
        }
        stu.unshift(value)
        if(stu.length>5){
          stu.pop()
        }
        this.historyList = stu
        stuStr = JSON.stringify(stu);
        localStorage[name] = stuStr;
      }else {//不存在时
        stu = [];//存储数据形式
        stu.unshift(value);
        stuStr = JSON.stringify(stu);
        localStorage[name] = stuStr;
      }
    },
    // 去详情
    goDetail (item) {
      if (item.module === '专题展览') {
        if(item.link){
          let params = {
            resId: item.id,
            resName: item.title,
            moduleName: '专题'
          }
          request('post', '/nlc-web/api/websiteData/res',params).then(res => {
            console.log('统计',res)
          })
          window.open(item.link)
        } else {
          if(!item.descHtml){
            this.getDirectory (item.id)
          } else {
            this.$router.push({name: 'articleDetails', params: {id: item.id}})
          }
        }
      } else if (item.module === '文津经典诵读') {
        request('get', '/nlc-web/api/poetryRead', {}, item.id).then(res => {
          this.$router.push({'name': 'poetryRead', query: {time: res.data.releaseDate}})
        })
      } else if (item.module === '国图预告') {
        this.$router.push({'name': 'exhibitionDetail', query: {id: item.id}})
      } else if (item.module === '信息资讯') {
        this.$router.push({'name': 'newsDetail', query: {id: item.id}})
      }
    },
    getDirectory (id) {
      request('get', '/nlc-web/api/special/cataloguesAll', {}, id).then(res => {
        console.log('目录列表', res)
        this.getLeave(res.data)
        this.$router.push({name: 'articleChildDetails', query: {id: this.leaveList[0], parentId:id}})
      })
    },
    // 查找子目录第一层级
    getLeave(data){
      if(data.length>0){
        this.getLeave(data[0].subsetList)
        this.leaveList.push(data[0].id)
      }
    },
    // 查看单册信息
    goView (message) {
      this.$router.push({name: 'opacView', query: {message: message}})
    },
    // 去数字资源详情
    goOnsite  (type,id) {
      // window.location.href = process.env.API_ROOT +'/nlc-api/api/readOpen/'+type+'/'+id
      window.open(process.env.API_ROOT +'/nlc-api/api/readOpen/'+type+'/'+id)
    },
    // 检索历史删除全部
    localDelete(){
      if (localStorage.getItem(`${history}`) === null){
        return
      }else {
        this.historyList = []
        Toast.success('删除成功')
        localStorage.removeItem(`${history}`);
      }
    },
    // 高亮显示（站内数字资源）
    highlights () {
      const search = this.searchTitle
      this.onsiteList = this.onsiteList.map(item => {
        for (let key in item) {
          if (key === 'title') {
            let replaceReg = new RegExp(search, 'g')// 匹配关键字正则
            let replaceString = '<span style="color:#008598">' + search + '</span>' // 高亮替换v-html值
            item[key + '-highlights'] = item[key].replace(replaceReg, replaceString) // 开始替换
          }
        }
        return item
      })
    },
    // 高亮显示（数字资源）
    resourceHighlights () {
      const search = this.searchTitle
      this.onsiteList = this.onsiteList.map(item => {
        for (let key in item) {
          if (key === 'name') {
            let replaceReg = new RegExp(search, 'g')// 匹配关键字正则
            let replaceString = '<span style="color:#008598">' + search + '</span>' // 高亮替换v-html值
            item[key + '-highlights'] = item[key].replace(replaceReg, replaceString) // 开始替换
          }
        }
        return item
      })
    },
    // 高亮显示（opac）
    opacHighlights () {
      const search = this.searchTitle
      this.opacList = this.opacList.map(item => {
        for (let key in item) {
          if (key === 'title') {
            let replaceReg = new RegExp(search, 'g')// 匹配关键字正则
            let replaceString = '<span style="color:#008598">' + search + '</span>' // 高亮替换v-html值
            item[key + '-highlights'] = item[key].replace(replaceReg, replaceString) // 开始替换
          }
        }
        return item
      })
    },
    // 检索字段选择
    onConfirm (value) {
      console.log('value', value)
      this.value = value.text
      this.opacCode = value.code
      this.showPicker = false
    },
    // 词临近选择
    onConfirm1 (value) {
      this.value1 = value
      this.showPicker1 = false
    },
    // 筛选出版年
    onConfirmSY (time) {
      this.showPickerSY = false
      this.startValue = {
        key: parseTime(time,'{y}'),
        code: 'WYR'
      }
    },
    // 筛选年取消
    yearCancel  () {
      this.showPickerSY = false
      this.startValue = {
        key: '全部',
        code: 'WYR'
      }
    },
    // 资料类型
    onConfirmTy (value) {
      this.showPickerTy = false
      this.dataText = value.text
      this.dataValue.key = value.value
    },
    // 数字资源
    onConfirmRe (value) {
      console.log('value',value)
      this.showPickerType = false
      this.reTypeValue = value.text
      this.resType = value.code
      this.params.pageNum = '1'
      this.onsiteList = []
      this.resourcesOnLoad()
    },
    // 重置
    filterReset () {
      this.startValue.key = '全部'
      this.dataValue.key = '全部'
      this.dataText= '全部'
      this.dataRadio= ['NLC01S']
    },
    // 筛选确认
    filterConfirm () {
      if(!this.searchTitle){
        Toast.fail('请输入搜索关键词')
        return;
      }
      this.params.pageNum = '1'
      this.opacList = []
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      if(this.dataRadio.indexOf('NLC01S')>-1){
        this.params.base = 'NLC01S'
      } else {
        this.params.base = 'NLC09S'
      }
      this.searchOpac ()
    },
    // 分享
    onShare () {
      event.stopPropagation()
      this.showShare = true
    },
    getShow (msg) {
      this.showShare = msg
    }
  },
  //home>serach>opacview  home>serach刷新 opacview>serach不刷新
  beforeRouteLeave(to, from, next) {
    if (to.name === 'opacView' || to.name === 'articleDetails'|| to.name === 'newsDetail'|| to.name === 'exhibitionDetail'|| to.name === 'poetryRead') {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();//不可缺少
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  position: absolute;
  top: 0px;
  min-height:100%;
}
.search{
  width:6.94rem;
  height:.8rem;
  margin:.2rem .28rem .2rem .28rem;
  background:#fff;
  border-radius:40px;
  font-size:.28rem;
  position:relative;
}
.van-search{
  width:6.8rem;
  height:.8rem;
  border-radius:40px;
  padding:0;
}
.van-search__content{
  background:#fff;
  height:.75rem;
  border-radius:40px;
}
.main{
  width:6.43rem;
  margin:.16rem .28rem 0 .28rem;
  padding:.32rem .25rem .25rem .25rem;
  background:#fff;
  border-radius:8px;
}
h1{
  font-size:.36rem;
  color:#008598;
  font-weight: 600;
  font-family: SourceHanSerifCN-SemiBold;
  margin:0;
}
.more-select{
  font-size: .36rem;
  color: #444649;
  margin:0;
  padding:0 0 .24rem 0;
  font-family: SourceHanSerifCN-SemiBold;
}
.van-radio{
  font-size:.28rem;
  color:#444649;
  font-family: SourceHanSerifCN-Light;
}
.opac-select .van-cell--clickable{
  background:#ECF5FD;
  border-radius:43px;
  border:none;
  margin-bottom:.16rem;
}
.van-radio--horizontal{
  margin-right:.22rem;
}
.van-field__control{
  border-left: 1px solid #BFC6CC !important;
  padding-left:.4rem !important;
}
.van-cell{
  padding:.1rem 0;
}
.label{
  position:relative;
  margin-left:.3rem;
}
.label-bor{
  width:1px;
  height:.56rem;
  display:inline-block;
  background: #BFC6CC;
  position:absolute;
  left:1.3rem;
  top:.08rem;
}
.van-cell__title{
  font-size:.3rem;
  color:#444649;
}
.onsite-title{
  display:inline-block;
  width:4.5rem;
  height: .4rem;
  line-height: .4rem;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.opacList-view{
  width: 3rem;
  height: .56rem;
  font-size:.28rem;
  border-radius: 60px;
  border:none;
  color:#fff;
  font-family: SourceHanSerifCN-Medium;
}
.on-site .van-cell__label{
  position:relative;
}
.search-source{
  position:absolute;
  right:.1rem;
}
.no-list{
  width:3.58rem;
  height:3.58rem;
  margin:1.9rem 1.6rem;
  text-align:center;
  background:url(../../assets/img/no.png) no-repeat;
  background-size:100%;
  position:relative;
}
.no-list p{
  position:absolute;
  bottom:0;
  left:.39rem;
  font-size:.28rem;
  color:#333;
  font-family: SourceHanSerifCN-Light;
}
.search-btn{
  width:1.44rem;
  height:.64rem;
  text-align:center;
  border-radius:60px;
  border:none;
  color:#fff;
  font-size: .32rem;
  font-family: SourceHanSerifCN-SemiBold;
}
>>>.van-tab--active{
  font-size:.36rem !important;
}
.van-list{
  margin-top:.1rem;
}
>>>.van-tab{
  font-family: SourceHanSerifCN-Regular;
}
.list-border::after{
  border-bottom: 1px solid #B3BBC3;
  left:0;
  right:0;
}
.opac-select >>>.van-icon-arrow-down{
  padding-right:.4rem;
}
.history{
  padding-bottom:.32rem;
}
.history >>>.van-cell__title{
  line-height:.51rem;
  font-size:.36rem;
  font-family: SourceHanSerifCN-SemiBold;
  color: #444649;
  font-weight: 600;
}
.history >>>.van-cell::after{
  border:none;
}
.history >>>.van-cell{
  padding: 0 0 .15rem 0;
}
.history-list{
  font-size: .28rem;
  font-family: SourceHanSerifCN-Regular;
  color: #94979C;
}
.history-list li{
  display:inline-block;
  background:#ECF5FD;
  border-radius:28px;
  padding:.14rem .24rem;
  margin:.16rem .24rem 0 0;
}
.filter{
  width:6.43rem;
  background: #ECF5FD;
  border-radius: 8px;
}
.filter-title {
  font-size:.28rem;
  text-align:center;
  line-height:.8rem;
  margin:.32rem 0 0 0;
}
.filter-content{
  border-top:1px solid #BFC6CC;
  padding:0 0 .15rem 0;
  margin:0 .17rem;
}
.filter-list{
  height:.56rem;
  line-height:.56rem;
  font-family: SourceHanSerifCN-SemiBold;
  font-weight: 600;
  display:flex;
  margin-top:.16rem;
}
.filter-list >>>.van-field__label{
  width:1.1rem;
  font-size:.24rem;
  margin-right:0;
}
.filter-list >>>.van-cell{
  padding:0;
  background:none;
}
.filter-list-col:nth-child(2){
  margin-left:.3rem
}
.filter-list >>>.van-field__control{
  width:4.5rem;
  height:.56rem;
  line-height:.56rem;
  border-radius:28px;
  background:#fff;
  font-size: .24rem;
  font-family: SourceHanSerifCN-Regular;
  padding:0 .14rem;
}
.resources-filter{
  /*position:absolute;*/
  /*right:.5rem;*/
}
.resources-filter >>>.van-field{
  width:1.76rem;
  height:.56rem;
  background:#fff;
  border-radius:30px;
}
.resources-filter >>>.van-cell{
  padding: 0;
  line-height:.56rem;
}
.resources-filter >>>.van-field__control{
  text-align:right;
  font-size:.24rem;
  padding-left:.1rem;
  color:#94979C;
}
.resources-filter >>>.van-field__right-icon{
  margin-right:5px;
  padding:0 4px;
}
>>>.van-picker-column:nth-child(2){
  display:none;
}
.filter-btn{
  border-top:1px solid #BFC6CC;
  height: .72rem;
}
.filter-btn button{
  width:2.76rem;
  height:.56rem;
  color:#fff;
  font-family: SourceHanSerifCN-SemiBold;
  margin:.16rem 0 0 .15rem;
  font-size:.24rem;
  vertical-align: top;
}
.filter-reset{
  border-radius: 30px;
}
.filter-confirm{
  border-radius: 60px;
  border:none;
}
.filter-last{
  padding-bottom:.16rem;
}
.filter-file >>>.van-field__value{
  background:#fff;
  border-radius:30px;
}
.filter-file >>>.van-field__right-icon{
  margin-right:.1rem !important;
  font-size:10px;
}
>>>.van-field__clear, .van-field__right-icon{
  padding:0;
}
.search-inp >>>.van-field__control{
  font-size:.28rem;
  line-height:.68rem;
}
>>>.van-icon-search{
  font-size:.32rem;
}
.delete{
  font-size:.24rem;
}
>>>.van-tabs__wrap{
  height:.65rem;
}
>>>.van-tab__text--ellipsis{
  line-height:.5rem;
}
>>>.van-tab--active .van-tab__text--ellipsis{
  font-size:.34rem !important;
  line-height: .34rem;
}
>>>.van-tab__text--ellipsis{
  font-size:.28rem;
  line-height: .32rem;
  font-family: SourceHanSerifCN-Regular
}
>>>.van-tab{
  font-size:.28rem;
}
.file-label{
  font-size:.28rem;
  line-height:.72rem;
  font-family: SourceHanSerifCN-Medium;
}
.opac-select{
  margin-bottom:.2rem;
}
.opac-select >>>.van-field__control{
  font-family: SourceHanSerifCN-Medium;
}
.opac-select >>>.van-field__label{
  width:1.5rem;
}
.opac-select >>>.van-cell__value{
  line-height:.72rem;
  margin-left:.15rem;
}
.opac-select >>>.van-field__right-icon .van-icon{
  font-size:.32rem !important;
}
.opac-select >>>.van-radio__label{
  line-height:.42rem;
}
.filter-width >>>.van-cell__value{
  width:1.8rem;
}
.search-inp >>>.van-field__control{
  font-family: SourceHanSerifCN-Medium;
}
.search-inp >>>.van-field__clear{
  margin-right:-.05rem !important;
}
.all-title{
  font-size:.28rem;
  color:#444649;
  padding: .35rem 0 .2rem 0;
  height: .3rem;
}
.add-box{
  float: left;
}

.all-data{
  float: right;
}
.all-total{
  color:#008598;
}
.radio-label{
  font-size: .24rem;
  color:#646566;
  line-height:.5rem;
  display:inline-block;
  width:1.1rem;
}
>>>.van-checkbox__label{
  font-size:.26rem;
}
>>>.van-radio__icon--checked .van-icon {
  color: #fff;
  background-color: #008598;
  border-color: #008598;
}
.all-data-active{
  color:#018091;
}
>>>.van-field__clear{
  font-size:.5rem;
}
.resources-left{
  width:1.8rem;
  height:2.4rem;
  margin-right:.16rem;
  position:relative;
  border-radius: 8px;
}
.resources-categoryName{
  position:absolute;
  left:0;
  bottom:0;
  width:100%;
  height:.4rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 8px 8px;
  color:#fff;
  text-align:center;
  line-height:.4rem;
  font-size:.26rem;
}
.resources-img{
  width:100%;
  height:100%;
  border-radius:8px;
}
>>>.van-image__img{
  border-radius:8px;
}
.shortIntro{
  width:100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color:#444649;
  font-size:.28rem;
}
.author{
  color:#444649;
  font-size:.28rem;
}
.message-size{
  font-size:.28rem;
}
.onsite-label{
  font-size:.28rem;
}
.van-cell{
  line-height: normal;
}
.message-over{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.search_tip{
  color:#008598;
  font-size:.2rem;
  margin:1.1rem auto 0;
  width:6.9rem;
}
</style>



// WEBPACK FOOTER //
// src/view/search/index.vue